import Skeleton from '@/components/ui/Skeleton'
import { CARD_BODY, CARD_BOX, CARD_FOOT } from '@/features/courses/components/course-card-box'
import { cn } from '@/lib/utils'

/**
 * `CourseCard` while its course loads, built from the card's own boxes
 * (`course-card-box.ts`) so it is the loaded card's height at every width.
 * Light — Skeleton and class strings only — so a route's pending component
 * may draw a grid of these without pulling the card's own module into the
 * entry chunk.
 */
export default function CourseCardSkeleton({ className }: { className?: string }) {
  return (
    <div aria-hidden="true" className={cn(CARD_BOX, className)}>
      <Skeleton className="aspect-video w-full rounded-md" />
      <div className={CARD_BODY}>
        <div className="flex flex-col">
          <div className="flex h-6 items-center">
            <Skeleton className="h-4 w-11/12 rounded-xs" />
          </div>
          <div className="flex h-6 items-center">
            <Skeleton className="h-4 w-2/3 rounded-xs" />
          </div>
        </div>
        <div className="flex h-4 items-center">
          <Skeleton className="h-3 w-36 rounded-xs" />
        </div>
        <div className={CARD_FOOT}>
          <Skeleton className="h-4 w-24 rounded-xs" />
        </div>
      </div>
    </div>
  )
}
